import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import InputPeople from "./InputPeople"
import { useTour } from "@/hooks/tour/useTour"
import { useMemo } from "react"
import { tourActions } from "@/lib/redux/features/tour/reduce"
import { useTranslation } from "react-i18next"
import _ from "lodash"

const InputAdult = () => {
  const inputAdt = useAppSelector(state => state.tour.inputTour.inputAdt)
  const selectedDepartureSchedule = useAppSelector(state => state.tour.inputTour.selectedDepartureSchedule)
  const { tour: { data: tour } } = useTour()
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  

  const priceAdt = useMemo(() => {
    if (!selectedDepartureSchedule) {
      return 0
    }
    const departureSchedule: any = tour?.departureSchedule?.find(d => d.id === selectedDepartureSchedule)
    return departureSchedule?.prices[0]?.priceAdt
  }, [selectedDepartureSchedule, tour?.departureSchedule])

  return (
    <InputPeople
      label={t("common.adult")}
      subLabel={`> ${tour?.agesAdults} ${_.lowerFirst(t("common.years_old"))}`}
      value={inputAdt}
      price={priceAdt}
      min={1}
      onChange={(val) => dispatch(tourActions.inputPeople({ type: 'ADT', value: val }))}
    />
  )
}

export default InputAdult